import {IOwnedEntity, IPublishableOwnedEntity} from "./i-owned-entity";
import { IBaseOwner } from './i-base-owner';

export interface ILanguage<T extends IBaseOwner | string = any> extends IPublishableOwnedEntity<T> {
  code: string;
  name: string;

}
